import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { sortArrayByKey } from '@client/shared/utils/jsUtils/jsUtils';
import Notification from '@client/containers/notificationListing/notification/Notification';
import { clearNotification } from '../../redux/notification/notificationActions';

class NotificationListing extends PureComponent {
  constructor(props) {
    super(props);
  }

  handleClearNotification(id) {
    this.props.dispatch(clearNotification(id));
  }

  render() {
    const { notifications } = this.props;

    return (
      <>
        {notifications &&
          sortArrayByKey(notifications, 'id', true).map(
            (notification, index) => {
              return (
                <Notification
                  key={notification.id}
                  notification={notification}
                  index={index}
                  onDelete={() => this.handleClearNotification(notification.id)}
                />
              );
            }
          )}
      </>
    );
  }
}
NotificationListing.propTypes = {
  notifications: PropTypes.array,
  dispatch: PropTypes.func,
};

export default connect()(NotificationListing);
